import { useEffect, useState } from 'react';

import type { Cookies } from 'client-site-chrome-ui/types/cookies';

interface UseGoogleUserIdParams {
  cookieName: string;
  cookies?: Cookies;
}

export const useCookieValue = ({ cookieName, cookies }: UseGoogleUserIdParams) => {
  const [value, setValue] = useState<string | null | undefined>(null);

  useEffect(() => {
    if (cookies) {
      setValue(cookies.get(cookieName));
    }
  }, []);

  return { value };
};
